// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_oc-0";
export var animationContainer = "_oc-1";
export var itemPrice = "_oc-a";
export var itemizedContent = "_oc-9";
export var itemizedHeader = "_oc-7";
export var itemizedRow = "_oc-8";
export var itemizedSection = "_oc-6";
export var modalContent = "_oc-2";
export var orderName = "_oc-3";
export var refundOption = "_oc-4";
export var refundOptionsContainer = "_oc-5";
export var shippingLabel = "_oc-b";
export var totalRow = "_oc-c";